import React, { useState, useEffect } from "react"
import { t } from '@/utils/i18n'
import styles from './ConvertOrderQuantity.module.less'

interface IProps {
  quantity: number // 下单数量
  unitList: any[] // 单位列表
  moqUnitIndex: number // 起订量单位索引
}

const ConvertOrderQuantity: React.FC<IProps> = (props) => {
  const { quantity, unitList = [], moqUnitIndex } = props
  const [unitLabel, setUnitLabel] = useState('') // 规格

  function unitConversion() {

    // 起订单位大于基础单位才计算转换逻辑
    if (moqUnitIndex > 0 && Number(quantity) > 0) {
      // 换算小单位数量
      const label = `${quantity} ${unitList[moqUnitIndex].unitName}, ${t('共')}  ${Number(quantity) * unitList[moqUnitIndex].unitRatio} ${unitList[0].unitName}`
      setUnitLabel(label)
    }

    if (quantity === 0) {
      setUnitLabel('')
    }
  }

  useEffect(() => {
    unitConversion()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  return unitList.length > 1 ? (
    <div className={styles['text-wrap']}>
      {unitLabel}
    </div>
  ) : ('')
}

export default ConvertOrderQuantity
